import axios, { CancelToken } from 'axios';
import useSetUser from '../../../hooks/useSetUser';
import useSetTokenSSO from '../../../hooks/useSetTokenSSO';

const protocol = `http${process.env.DEFAULT_SECURE && 's'}://`;

const getAccessToken = () => {
  const source = CancelToken.source();

  setTimeout(() => {
    source.cancel();
  }, 30000);

  return axios({
    baseURL: `${protocol}${process.env.LM_BASE_URL}api/loginManager/refresh`,
    cancelToken: source.token,
    headers: {
      'lm-api-key': `${process.env.LM_APIKEY}`,
    },
    method: 'post',
    withCredentials: true,
  })
    .then(response => ({
      accessToken: response.data.access_token,
      refreshToken: response.data.refresh_token,
    }))
    .catch(() => ({
      unlogged: true,
    }));
};

const getTmfToken = accessToken => {
  return axios({
    method: 'post',
    url: `${protocol}${process.env.API_BASE_URL_MULTI}auth/login-manager/login`,
    data: { accessToken },
  });
};

const useLogin = () => {
  const setUser = useSetUser();
  const setTokenSSO = useSetTokenSSO();

  return async () => {
    const { accessToken, refreshToken } = await getAccessToken();

    if (accessToken) {
      try {
        const { data, status } = await getTmfToken(accessToken);
        if (status === 200) {
          setUser(data);
          if (refreshToken) {
            setTokenSSO(accessToken);
          }
        }
        return { status };
      } catch ({
        response: {
          data: { message },
          status,
        },
      }) {
        // Darkside status === 403
        // Access Token expired status === 401
        return { status };
      }
    } else return { status: 404 };
  };
};

export default useLogin;
